/**
 * WebSocket 客户端封装
 * 从 kefu frontend/src/utils/websocket.js 平移过来,保持 API 与重连逻辑一致。
 */
export class ChatWebSocket {
    constructor(url) {
        this.url = url
        this.ws = null
        this.listeners = new Map()
        this.reconnectAttempts = 0
        this.maxReconnectAttempts = 5
        this.reconnectDelay = 3000
        this.shouldReconnect = true
    }

    connect() {
        return new Promise((resolve, reject) => {
            try {
                this.ws = new WebSocket(this.url)
                this.ws.onopen = (event) => {
                    this.reconnectAttempts = 0
                    this.emit('open', event)
                    resolve(event)
                }
                this.ws.onmessage = (event) => {
                    try {
                        const data = JSON.parse(event.data)
                        this.emit('message', data)
                    } catch (e) {
                        console.error('解析消息失败', e)
                    }
                }
                this.ws.onclose = (event) => {
                    this.emit('close', event)
                    if (this.shouldReconnect && this.reconnectAttempts < this.maxReconnectAttempts) {
                        this.reconnect()
                    }
                }
                this.ws.onerror = (event) => {
                    this.emit('error', event)
                    reject(event)
                }
            } catch (e) {
                reject(e)
            }
        })
    }

    reconnect() {
        this.reconnectAttempts++
        const delay = this.reconnectDelay * this.reconnectAttempts
        console.log(`WebSocket ${this.reconnectAttempts}次重连，${delay}ms后`)
        setTimeout(() => {
            if (this.shouldReconnect) {
                this.connect().catch(() => {})
            }
        }, delay)
    }

    send(data) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(data))
            return true
        }
        return false
    }

    close() {
        this.shouldReconnect = false
        if (this.ws) {
            this.ws.close()
        }
    }

    on(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, [])
        }
        this.listeners.get(event).push(callback)
    }

    off(event, callback) {
        if (!this.listeners.has(event)) return
        const list = this.listeners.get(event)
        const idx = list.indexOf(callback)
        if (idx > -1) list.splice(idx, 1)
    }

    emit(event, data) {
        if (!this.listeners.has(event)) return
        this.listeners.get(event).forEach((cb) => cb(data))
    }
}

/**
 * 创建聊天 WebSocket 实例。
 * 后端地址统一从 ./config.js 的 KF_WS_BASE 读取。
 * 生产环境部署时,如需修改后端地址,请改 config.js 单文件,不要直接动这里。
 */
import { KF_WS_BASE } from './config'

export function createChatWebSocket() {
    const url = `${KF_WS_BASE}/ws/chat`
    return new ChatWebSocket(url)
}